import React from "react";

export const aboutPage5 = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		version="1.1"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		preserveAspectRatio="none"
		x="0px"
		y="0px"
		width="329px"
		height="191px"
		viewBox="0 0 329 191"
		id="frame-5"
	>
		<defs>
			<linearGradient
				id="Gradient_2"
				gradientUnits="userSpaceOnUse"
				x1="172.44999999999993"
				y1="785.2"
				x2="1465.65"
				y2="231.59999999999997"
				spreadMethod="pad"
			>
				<stop offset="4.705882352941177%" stopColor="#2DFCD8" />

				<stop offset="5.882352941176471%" stopColor="#2BF0CE" />

				<stop offset="11.764705882352942%" stopColor="#21BBA1" />

				<stop offset="18.03921568627451%" stopColor="#198C79" />

				<stop offset="24.313725490196077%" stopColor="#136558" />

				<stop offset="30.58823529411765%" stopColor="#0F453C" />

				<stop offset="37.254901960784316%" stopColor="#0D2C27" />

				<stop offset="43.92156862745098%" stopColor="#0C1A18" />

				<stop offset="51.372549019607845%" stopColor="#0C0F0F" />

				<stop offset="59.6078431372549%" stopColor="#0C0C0C" />
			</linearGradient>

			<g id="Layer15_0_FILL">
				<path
					fill="url(#Gradient_2)"
					stroke="none"
					d="
M 1147.65 788.45
L 894.9 73.05 184.75 682.3 285.45 997.85 1147.65 788.45 Z"
				/>
			</g>

			<g id="Layer14_0_FILL">
				<path
					fill="#0C0C0C"
					stroke="none"
					d="
M 426.2 703.75
L 207.6 651.85 -17.35 777.05 -130.75 1054.65 118.55 1261.6 474.7 988.6 426.2 703.75 Z"
				/>
			</g>

			<g id="Layer13_0_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 710.9 312.65
Q 698.85 317 691.05 321 680.35 326.4 673.25 333 658.2 346.95 660.2 368.25 662.15 388.7 677.85 402.2 694.2 416.25 718.8 419.05 738.4 421.3 763.7 416.4 778.6 413.55 788.6 410.5 802.05 406.35 812.1 400.5 816.5 397.95 821.7 393.8 824.75 391.35 830.65 386.3 839.95 378.5 851.85 375.8 852.4 375.65 852.5 375 852.6 374.3 852.1 374.05 845.5 371.05 837.4 375.3 833.05 377.55 824.75 384.6 816.2 391.9 807.35 396.85 798.15 401.95 787.7 405.15 762.9 412.65 743.4 414.25 718 416.25 699.1 408.65 689.2 404.65 681.6 398.15 673.4 391.1 669.1 382.1 664.5 372.55 664.65 362.2 664.85 351.25 670.4 342.8 675.8 334.55 686.4 327.95 693.85 323.35 706.3 318.35 725.9 310.5 747.35 307.2 771.4 303.65 796.15 306.3 807.55 307.55 820.2 310.75 830.4 313.3 843.6 317.75 844.7 318.15 845.2 316.95 845.7 315.8 844.65 315.3 824.9 306.2 800.85 303 778.55 300.05 755.3 302.5 732.05 304.95 710.9 312.65 Z"
				/>
			</g>

			<g id="Layer13_1_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 862.1 325.6
Q 862.3 325.6 862.3 325.45
L 862.3 325.35
Q 862.3560546875 325.41640625 862.4 325.45 863.3 326.15 866.05 327.15
L 873.85 331.1
Q 883.25 335.85 889.5 338.3 910.05 346.3 919.8 341.15 921.1 340.45 920.65 339.05 920.2 337.65 918.8 337.55 916.65 337.4 910.9 337.7 905.95 338 902.9 337.45 896.65 336.35 888.25 333.05 884.25 331.45 873.45 326.6 869.8 324.8 867.75 323.9 864.1 322.35 861.75 322.55 860.7 322.65 860.45 323.55 859.95 325.6 862.1 325.6
M 861.6 325.25
Q 861.5671875 324.9546875 861.9 325.1 861.644140625 325.91171875 861.6 325.25 Z"
				/>
			</g>

			<g id="Layer13_2_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 911.35 313.5
Q 911.426953125 313.4287109375 911.5 313.35 912.15 312.55 911.85 311.55 910.8 307.7 906.35 307.5 902.901953125 307.3041015625 901.3 309.6 898.846875 309.376171875 896.8 310.65 893.730078125 311.28984375 892.7 313.35 891.6 315.65 892.9 318.05 894.1 320.3 896.5 321.15 898.0205078125 321.6705078125 899.75 321.8 900.50234375 322.9291015625 901.75 323.65 903.75 324.8 906.25 324.4 908.7 324 910.15 322.25 911.2814453125 320.90625 911.35 319.15 911.744921875 318.8115234375 911.95 318.35 912.1638671875 317.9220703125 912.15 317.45 912.5744140625 317.047265625 912.75 316.45 913.05 315.55 912.5 314.85 911.9689453125 314.103125 911.35 313.5
M 896.7 315.75
Q 897.538671875 316.6583984375 898.5 317.35 897.2740234375 317.1142578125 896.9 316.4 896.694921875 316.0353515625 896.7 315.75 Z"
				/>
			</g>

			<g id="Layer13_3_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 1016.8 341.4
Q 1017.15 341.4 1017.15 341.05 1017.3 337.6 1018.75 335.7 1020.3 333.65 1023.6 332.9 1028.8 331.75 1035.95 332.4 1042.3 333 1047.35 335.55 1053 338.4 1056.1 343.35 1059.35 348.55 1058.4 354.2 1057.45 359.6 1053 364 1049.4 367.55 1042.5 370.1 1033.2 373.5 1031.25 374.6 1029.95 375.3 1030.35 376.9 1030.75 378.45 1032.3 378.4 1040.4 378.05 1048.65 373.45 1057.25 368.7 1061.1 361.9 1065 355.15 1063.25 347.25 1061.65 339.7 1055.65 334.4 1049.65 329.05 1040.55 327.3 1032.5 325.8 1023.65 327.3 1019.7 328 1017.15 329.7 1013.9 331.8 1013.3 335.2 1012.85 337.65 1013.65 339.3 1014.5 341.2 1016.8 341.4 Z"
				/>
			</g>

			<g id="Layer13_4_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 1021.1 344.95
Q 1021.25 345.5 1021.75 345.45 1023.55 345.25 1026.1 345.6 1028.4 345.9 1030.35 346.45 1032.15 347 1034.2 348.45 1035.4 349.25 1037.75 350.95 1039.1 351.8 1040.2 350.6 1041.3 349.45 1040.55 348.1 1039.4 345.9 1036.7 344.3 1034.4 342.95 1031.5 342.3 1029 341.75 1026.3 341.95 1024.8 342.15 1023.7 342.7 1022.4 343.55 1021.4 344.15 1021 344.4 1021.1 344.95 Z"
				/>
			</g>

			<g id="Layer13_5_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 835.05 158.7
Q 834.05 160.15 834.75 161.75 847.17734375 190.3294921875 871.05 214.05 840.3833984375 197.2953125 813.2 188.55 765.6 173.25 724.5 180.75 723 181.05 722.55 182.75 722.1 184.45 723.25 185.45 745.35 205.05 770.25 218.3 771.196875 218.8052734375 772.15 219.3 770.21171875 218.966015625 768.25 218.65 739.55 214.05 709.5 214.5 708.35 214.5 707.5 215.3 706.65 216.15 706.7 217.3 707.1 226.3 716.85 233.6 721.55 237.15 734.55 243.45 757.25 254.35 780.35 258.35 781.95 258.6 782.4 257.05 782.85 255.45 781.25 255.1 759.4 249.6 741.95 241.25 733 236.95 724.85 232.05 719.15 228.55 716.6 226.1 713.6845703125 223.21953125 712.7 220.05 759.5568359375 220.1904296875 808.75 234.4 816.1876953125 236.5421875 823.65 239 826.25 239.75 826.95 237.15 827.6 234.6 825.15 233.65 810.4556640625 228.084765625 794.75 224.1 783.813671875 219.6546875 772.95 213.75 750.9423828125 201.8478515625 731.6 185.3 769.093359375 180.0962890625 812.3 194.7 841.75 204.65 891.8 232.1 894 233.35 895.25 231.2 896.45 229.05 894.4 227.65 876.65 215.4 862.3 197.1 850.7865234375 182.4193359375 842.25 164.95 873.6623046875 175.909375 900.15 196.45 928.55 218.5 948.75 249.65 949.5 250.85 950.8 250.1 952.05 249.4 951.3 248.15 932.8 216.6 902.7 192.75 873.05 169.3 837.85 157.75 836.05 157.15 835.05 158.7 Z"
				/>
			</g>

			<g id="Layer13_6_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 1064.7 238.9
Q 1064.55 237.05 1062.65 236.55 1042.25 231.1 1022.35 233.7 1012.2 235 1002.7 238.1 996.95 240 993.85 241.4 988.8 243.65 985.85 246.4 985.25 247 985.7 247.7 986.15 248.35 986.9 248.2 990.3 247.55 995.85 245.4 1002.5 242.9 1004.75 242.25 1014.2 239.55 1023.55 238.75 1039.58046875 237.2927734375 1054.95 240.55 1046.301953125 246.2017578125 1037.3 250 1031.75 252.4 1024.95 254.45 1023.4 254.9 1018.35 255.95 1014.15 256.85 1011.85 257.75 1010 258.5 1010.2 260.45 1010.4 262.4 1012.5 262.5 1018.2 262.75 1026.15 260.35 1030.7 258.95 1039.2 255.45 1051.85 250.2 1063.35 241.8 1064.85 240.7 1064.7 238.9 Z"
				/>
			</g>

			<g id="Layer13_7_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 950.35 525.7
Q 950.65 526.8 951.7 526.75 960.55 526.4 971.3 521.9 979.25 518.55 989.3 512.35 1007.5 501.3 1021.15 485.5 1026.05 479.85 1034.95 467.65 1043.2 457 1050.8 451.8 1059.25 446 1069.7 443.15 1079.65 440.45 1090.35 440.65 1104.85 440.95 1115.75 445.4 1131.4 451.8 1126.7 464 1125.85 466.25 1128.25 467.25 1130.7 468.2 1131.85 466.15 1137.1 456.8 1129.5 448.25 1123.25 441.25 1112.7 438.1 1102.05 434.9 1090.75 434.65 1079.35 434.4 1068.7 437.2 1047 442.95 1032.05 461.75 1016.75 481 1016.5 481.25 1007.45 492 998.8 498.8 988.45 506.95 976.1 513.2 972.15 515.15 963.5 518.6 955.15 521.95 950.95 524.1 950 524.6 950.35 525.7 Z"
				/>
			</g>

			<g id="Layer13_8_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 962.7 410.85
Q 959.2 405.5 952.3 404.55 946.55 403.8 939.85 406.1 939.05 406.4 939.15 407.3 939.25 408.2 940.15 408.15 949.2 407.65 951.3 408 957.3 408.9 960.05 414 962.55 418.7 961.35 425.1 960.65 428.75 958.7 436.1 958.45 437.45 959.7 438.05 961 438.65 961.75 437.4 965.25 431.45 965.7 424.15 966.2 416.25 962.7 410.85 Z"
				/>
			</g>

			<g id="Layer13_9_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 938.95 425.15
Q 935.9 425.85 932.65 428.7 931.1 430 927.5 433.9 923.65 438.2 921.6 440.25 918.1 443.7 914.8 445.45 907.35 449.4 895.95 448.5 882.8 446.45 876.7 445.5 856.65 442.45 837.9 445.45 818.2 448.55 811.5 458.55 810.95 459.4 811.75 460.2 812.5 460.95 813.35 460.4 821.25 455.4 828.95 452.75 836.85 450.05 846 449.4 855.35 448.75 866.5 449.8 873.75 450.5 886.85 452.6 896.3 454.1 902.5 453.9 911.15 453.6 917.55 450.2 920.65 448.55 923.9 445.6 925.9 443.8 929.4 440.05 931.45 437.8 935.25 434.5 939.7 430.65 941.25 429.15 942.55 427.9 941.6 426.35 940.65 424.75 938.95 425.15 Z"
				/>
			</g>

			<g id="Layer13_10_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 811.55 415.25
Q 811.4 415.1 811.3 415.2 808.85 416.85 807.55 421.25 807.35 421.9 806.1 428.45 804 439.7 804.55 446.85 804.75 449.4 807.2 449.4 809.65 449.4 809.85 446.85 810.05 444.25 810.35 438 810.65 432.3 810.95 429.1 811.8 424.55 812.15 422.1 812.75 417.65 811.55 415.25 Z"
				/>
			</g>

			<g id="Layer13_11_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 839.7 407.25
Q 838.25 406.65 837.5 408 835.9 410.95 832.5 419.45 831.75 421.35 830.05 425.25 828.7 428.65 828.5 431.25 828.35 432.85 829.95 433.15 831.45 433.45 832.3 432.3 833.75 430.35 834.95 427.1 836.15 423.3 836.8 421.5 839.85 413.1 840.75 409.35 841.15 407.9 839.7 407.25 Z"
				/>
			</g>

			<g id="Layer13_12_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 870.5 416.9
Q 870.15 416.1 869.35 416.3 864.15 417.75 860.85 420.6 858.65 422.45 857.4 424.3 855.65 426.95 856.4 428.9 856.75 429.7 857.4 430.15 858.2 430.65 858.95 430.35 860.5 429.7 861.7 427.6 862.4 426.45 863.7 424.05 866.45 420.15 870.1 418.1 870.85 417.7 870.5 416.9 Z"
				/>
			</g>

			<g id="Layer13_13_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 893.4 419.1
Q 891.95 418.9 891.4 420.35 890.05 424.35 889.25 429.25 888.75 432.05 891.4 432.4 894.05 432.8 894.4 429.95 895.1 424.7 894.9 420.8 894.85 419.25 893.4 419.1 Z"
				/>
			</g>

			<g id="Layer13_14_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 816.25 471.8
Q 814.75 471.45 814.05 472.65 811.8 476.7 810.85 478.1 810.6 478.45 808.95 480.65 807.75 482.2 807.25 483.35 806.45 485.1 807.75 486.55 809.1 488.05 810.9 487 813.85 485.25 815.75 481.15 817.35 477.6 817.7 473.65 817.8 472.2 816.25 471.8 Z"
				/>
			</g>

			<g id="Layer13_15_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 836.8 468.75
Q 835.8 468.85 835.5 469.85 835.4 470.05 835.05 470.7 834.75 471.2 834.7 471.7 834.65 472.2 834.7 472.95 834.75 473.35 834.85 474.15
L 835.35 479.4
Q 835.75 482.65 838.8 482.25 841.8 481.8 841.25 478.6
L 839.65 471
Q 839.45 470.6 839.05 470.15 838.55 469.7 838.4 469.45 837.8 468.6 836.8 468.75 Z"
				/>
			</g>

			<g id="Layer13_16_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 878.75 467.15
L 878.4 467.15 878.15 467.25
Q 876.6 467.85 876.45 469.5 876.1 473.1 874.9 475.75 873.65 478.45 871.1 481 869.1 482.95 871.05 484.9 873.05 486.8 875.15 485.05 878.55 482.25 880.15 477.7 881.75 473.25 881 468.85 880.75 467.45 878.75 467.15 Z"
				/>
			</g>

			<g id="Layer13_17_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 856.25 524.2
Q 857.3 517.55 850.55 514.9 844.5 512.5 836.5 513.85 829.5 515.05 823.1 518.65 816.8 522.15 812.2 527.6 809.637109375 530.669921875 807.75 534.15 803.8869140625 525.4134765625 798.45 519.9 789.15 510.55 777.6 513.7 773.45 514.85 770.45 518.35 767.65 521.65 766.8 525.95 766.32421875 528.25 766.5 530.35 766.219921875 530.1939453125 765.9 530 758.25 525.4 755.6 524 743.25 517.65 733.1 520.85 728.6 522.25 725.55 525.45 722.4 528.75 721.5 533.25 720.45 538.65 722.8 545.4 723.95 548.65 728 556.6 734.65 569.65 740 577.15 747.7 587.9 756.8 593.85 765.4 599.45 779.9 601.55 783.9 602.1 792.05 603 799.35 603.9 804.2 605.1 818.3 608.5 826.15 620.4 829.5 625.45 832.8 632.25 835.05 636.9 838.35 644.65 844.4 658.8 843.9 672.7 843.4 686.9 836.05 700.15 824.15 721.7 795.6 737.75 780.3 745.25 772.8 749.45 759.7 756.9 753.7 765.95 750.05 771.5 748.75 777.65 747.35 784.3 749.2 790.2 750.85 795.6 755.05 799.85 758.9 803.75 764.4 806.35 769.6 808.75 776.4 810.35 780.9 811.4 788.85 812.65 808.2 815.55 823.9 817.1 825.2 817.2 825.4 815.8 825.6 814.35 824.35 814.05 810.35 810.7 796.1 808 788.2 806.6 784.25 805.8 777.3 804.45 772.55 802.9 759.7 798.6 756.05 790.1 753.7 784.6 755.35 778.05 756.85 772.3 760.95 767.15 767.25 759.3 781.25 752.3 781.6 752.15 792.95 746.7 799.95 743.4 804.1 740.85 827.25 726.6 838.9 708.55 845.65 698.15 848.65 686.8 851.85 674.65 850.35 663.05 849.65 657.45 847.55 651.2 845.9 646.3 843 639.85 839.3 631.7 837.65 628.4 834.45 621.95 831.35 617.35 825.2 608.15 815.65 603.35 807.35 599.15 795.1 597.75 786.8 596.95 782.7 596.45 775.4 595.55 770.4 594.1 759.45 590.8 750.65 581.6 743.3 573.85 735.8 559.9 729.3 547.95 728.65 546.5 725.05 537.8 727.5 532.1 729.75 526.7 736.75 525.55 742.6 524.6 748.55 526.75 753.35 528.5 761.35 533.5 768.5982421875 537.976953125 772.7 539.9 773.060546875 540.0626953125 773.35 540.2 773.7251953125 540.3646484375 774.05 540.5 776.2 541.4 777.2 538.95 778.2 536.5 776.15 535.5 773.4 534.15 772.4 531.3 771.4 528.65 772.2 525.6 773.2 521.65 776.85 519.7 780.2 517.95 784.45 518.45 792.3 519.35 797.9 526.6 801.85 531.75 805.2 541.1 805.8 542.85 807.55 542.85 809.3 542.85 809.95 541.1 813.8 530.15 824.35 523.4 835.25 516.45 846.55 518.6 855.9 520.4 848.9 529.3 846.8 531.95 837.25 540.55 818.65 557.2 814.85 560.45 813.15 561.9 814.85 563.6 816.5 565.3 818.15 563.75 822.3 559.85 834.3 549.3 844.55 540.3 850.3 534.65 855.35 529.7 856.25 524.2 Z"
				/>
			</g>

			<g id="Layer13_18_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 868.5 578.5
Q 859.05 584.15 851.85 589.45 843.6 595.55 837.9 600.8 833.05 605.2 830.95 607.5 827.3 611.45 825.5 615.35 825.45 615.5 825.65 615.5 829.25 613.9 833.6 610.6 836.1 608.7 840.95 604.75 848.55 599 856.35 593.7 865.1 587.8 872.5 583.65 875.05 582.25 880.65 579.7 885.65 577.25 888.2 574.85 889.85 573.35 888.65 571.55 887.45 569.8 885.45 570.1 881.8 570.65 876.7 573.55 871 577.05 868.5 578.5 Z"
				/>
			</g>

			<g id="Layer13_19_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 883.75 581.35
Q 883.4 581.65 883.55 582.05 884.1 583.8 885.7 585.65 886.6 586.75 888.6 588.8 893.1 593.7 896.45 598.15 903.1 606.85 908.5 616.9 913.6 626.5 917.3 637.9 920.35 647.5 922.9 659.95 923.3 662.1 925.8 661.8 928.3 661.5 928.05 659.25 925.6 637.95 913.15 615.1 907.65 605.15 900.4 596.15 896.05 590.9 892.45 587.2 889.4 584.1 888.85 583.6 886.6 581.65 884.45 581.1 884.05 581 883.75 581.35 Z"
				/>
			</g>

			<g id="Layer13_20_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 1363.75 769.15
Q 1363.75 769.7 1364.2 769.9 1366.65 771.25 1370.25 771.4 1372.35 771.5 1376.65 771.35
L 1392.6 771.2
Q 1407.6 771.05 1422.6 770.75
L 1546.4 768.3
Q 1556.7 768.1 1577.35 767.85 1595.8 767.55 1608.3 766.8 1611.45 766.6 1611.45 763.45 1611.5 760.3 1608.3 760.25 1595.75 760.05 1577.35 760.65 1556.7 761.35 1546.4 761.6
L 1422.6 764.85
Q 1397.6 765.6 1392.6 765.8
L 1376.65 766.4
Q 1372.35 766.4 1370.2 766.6 1366.55 766.9 1364.2 768.35 1363.8 768.6 1363.75 769.15 Z"
				/>
			</g>

			<g id="Layer13_21_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 724.6 779.35
Q 708.1 778.7 694.7 778.35 659.35 777.55 633.9 777.25 574.15 776.5 512.3 777.2
L 477.45 777.75
Q 466.25 777.7 460.55 777.75 450.4 777.85 443.75 779.15 441.55 779.6 441.5 782.2 441.5 784.8 443.75 785.15 449.7 785.95 458.55 785.65 463.55 785.45 473.45 784.95 473.95 784.95 503.35 784.2 531.7 783.55 564.15 783.25 622.9 782.6 685.75 783.45
L 720.6 783.9
Q 726.05 784 737.25 784.45 747.1 784.6 753.75 783.5 754.55 783.35 754.5 782.5 754.5 781.65 753.75 781.45 747.9 780.1 739.25 779.75 729.4 779.55 724.6 779.35 Z"
				/>
			</g>

			<g id="Layer13_22_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 423.85 699.4
Q 422.6 699.55 422.75 700.7 425.15 721.95 430.45 752.1 433.5 769.2 439.7 803.3
L 457.8 907.3
Q 459.5 917.05 462.7 936.75 465.65 954.1 468.65 966.05 469 967.45 470.6 967.25 472.2 967.05 472.05 965.55 470.95 955.05 468.35 940.2 465.25 923.3 463.8 914.9
L 436.45 758.95
Q 433.1 739.35 431.35 729.55 428.25 712.55 425.35 700.3 425.1 699.25 423.85 699.4 Z"
				/>
			</g>

			<g id="Layer13_23_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 194.9 655.4
Q 194.35 655.6 194.5 656.2 195.4 660.15 197.6 666.15 200.8 674.85 201.15 675.95 204.25 685.5 207.05 696.05 209.5 705.15 212.15 716.9 213.5 722.7 216.8 737.85 223.1 766.65 226.4 778.4 232.7 801.05 241.2 817.2 241.6 817.9 242.5 817.55 243.35 817.2 243 816.45 235.6 798 229.5 776.4 224.4 758.5 219.4 735.3 213.5 707.9 209.85 694.35 205.65 678.65 204.25 674.4 200.5 662.85 195.7 655.65 195.4 655.2 194.9 655.4 Z"
				/>
			</g>

			<g id="Layer13_24_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 303.1 669.5
Q 275.95 663.6 248.8 658.1 239.75 656.3 221.55 652.9 212.45 651.2 207.85 650.5 203.55 649.7 201.3 649.4 197.45 648.8 194.75 649.2 194.4 649.25 194.3 649.6 194.15 649.9 194.5 650.1 196.85 651.5 200.55 652.5 202.65 653.05 206.9 654 209.95 654.85 220.35 657.25 238.95 661.65 248.25 663.75
L 302.3 676.1
Q 330.85 682.7 356.25 688.75
L 383.15 695.3
Q 387.75 696.4 397.05 698.9 405.3 700.95 411.1 701.4 413.95 701.6 414.15 698.85 414.3 696.1 411.95 695.1 406.75 692.95 398.7 691.05 389.55 689.1 385.15 688.05
L 358.15 681.8
Q 330.65 675.5 303.1 669.5 Z"
				/>
			</g>

			<g id="Layer13_25_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 473.2 967.25
Q 474.95 964.3 472.05 962.55 454.05 951.65 429.25 937.65 400.4 921.45 386 913.35 335.7 885.2 298.85 865.95 282.05 857.05 273.6 852.7 259 845.2 247.9 840.35 247.55 840.2 247.4 840.5 247.2 840.75 247.5 840.95 255.95 846.45 269 853.85 276.25 858 290.75 866.25 304.85 874.5 333.35 890.6 381.25 917.75 419.4 939.9 424.6 942.9 443.95 954.3 459.05 963.2 468.55 968.55 471.5 970.2 473.2 967.25 Z"
				/>
			</g>

			<g id="Layer13_26_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 639.5 884.3
Q 617.45 877.65 596.5 871.85 576.15 866.2 553.2 860.5 539.35 856.8 532.3 855.15 520.05 852.2 511.05 851.45 510.3 851.4 510.25 852.1 510.15 852.85 510.8 853.1 518.5 856.2 530.3 859.25 536.9 861 550.1 864.3 568.95 869.45 588.55 875.1 608.95 881 626.8 886.55
L 655.55 895.6
Q 656.7 895.95 660.3 896.9 663.35 898.05 663.7 899.9 664.2 902.75 667.1 901.95 670 901.1 669.45 898.3 668.95 895.4 666.3 893.5 664.45 892.2 660.85 891 652.25 888.15 639.5 884.3 Z"
				/>
			</g>

			<g id="Layer13_27_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 619.2 914.4
Q 584.7 923.7 567.4 928.3
L 490.55 948.85
Q 488.35 949.45 477.2 952.7 472.2 954.15 471.35 954.5 468.05 955.65 465.9 957.25 465.45 957.55 465.6 958 465.7 958.45 466.25 958.5 468.9 958.8 472.35 958.2 473.45 958 478.35 956.9 490.2 954.15 491.9 953.7
L 568.9 933.9
Q 586.25 929.45 620.9 920.6 651.95 912.65 672.85 907 675.85 906.2 675 903.1 674.2 900 671.15 900.75 650.05 906.1 619.2 914.4 Z"
				/>
			</g>

			<g id="Layer13_28_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 1314.9 596.6
Q 1343.2 628.65 1368 665.3 1381.2 684.8 1393.85 706.95 1400.6 718.95 1405.55 728.5 1406.55 730.4 1408.6 734.25 1410.35 737.65 1411.35 740.15 1412.85 744.1 1411.95 748 1410.8 752.7 1406.2 751.45 1404.1 750.85 1403.5 752.95 1402.95 755.05 1405 755.8 1408.6 757.15 1412 755.3 1415.25 753.55 1416.75 749.9 1418.25 746.1 1416.95 741.2 1416.15 738.3 1413.5 732.95 1402.8 711.65 1390.35 690.75 1365.2 648.65 1335.4 611.9 1320.4 593.35 1303.7 575.65 1300.05 571.75 1286.2 557.7 1275.35 546.65 1269.05 539.45 1264.1 533.8 1256.25 523.55 1246.9 511.25 1243.6 507.2 1228.15 488.3 1213.15 480.25 1191.3 468.5 1163.35 474.55 1140.6 479.5 1116.5 495.35 1115.05 496.3 1115.9 497.75 1116.75 499.2 1118.3 498.4 1144.6 485.55 1159.75 481.6 1184.35 475.15 1203.5 482.45 1218.5 488.2 1232.9 504.05 1238 509.65 1244.8 518.45 1248.6 523.4 1255.95 533 1266.05 545.75 1285 565.15 1307.75 588.45 1314.9 596.6 Z"
				/>
			</g>

			<g id="Layer13_29_MEMBER_100_FILL">
				<path
					fill="#DDDBDB"
					stroke="none"
					d="
M 1030.7 775.9
Q 1034.8 768.85 1041.95 761.8 1052.75 751.1 1069.95 742.2 1080.8 736.55 1101.45 728.45 1113.2 723.8 1121.85 723.15 1126.45 722.85 1132.45 723.1 1134.55 723.2 1143 723.8 1165.3 725.3 1186.05 726 1209 726.8 1229.15 726.8 1235.1 726.85 1247.55 727 1258.4 726.65 1265.65 724.15 1270.1 722.65 1273.2 720.55 1277.35 717.7 1278.45 714.25 1279.6 710.65 1276.95 706.9 1275.65 705.1 1271.45 701.25 1254.75 685.7 1237.35 681 1236.55 680.8 1236.25 681.5 1235.95 682.25 1236.6 682.7 1250.85 692.8 1252.8 694.25 1261.9 701.05 1268.05 707.05 1268.55 707.5 1270.15 708.9 1271.6 710.25 1271.8 711.05 1272.2 712.5 1270.95 713.75 1270.55 714.15 1268.55 715.45 1265.4 717.45 1260.95 718.55 1256.7 719.65 1251 719.9 1248.7 720 1240.9 720 1196.15 720.15 1150.8 717.2 1131.05 715.95 1129.35 715.95 1117.15 715.75 1108.1 718.45 1100.25 720.75 1090.8 724.75 1084.4 727.4 1073.95 732.3 1056.15 740.55 1044.6 749.4 1029.45 761 1022.9 775.05 1019.05 783.4 1021.45 790.7 1024.15 798.8 1033.35 799.75 1044.1572265625 800.8705078125 1056.95 792.2 1056.00234375 798.2349609375 1058.1 803.05 1060 807.4 1063.55 809.95 1067.4 812.65 1071.95 812.25 1076.25 811.85 1079.75 808.65 1082.85 805.8 1084.65 801.45 1084.973046875 800.659375 1085.2 799.75 1089.0736328125 810.03515625 1099.15 810.4 1104.4 810.6 1109.4 807.7 1114.1 804.95 1117.05 800.35 1120.35 795.3 1121.45 787.8 1122.1 783.05 1122.05 774.35 1122.05 770.7 1118.25 770.7 1114.45 770.7 1114.5 774.35 1114.5 781.6 1114.2 784.65 1113.65 790.45 1111.65 794.55 1109.5 798.9 1105.25 801.35 1100.45 804.1 1096.3 802 1093.15 800.45 1091.65 796.15 1090.95 794.25 1090 788.5 1089.1 783 1088.6 780.7 1087.55 776.4 1085.95 773.2 1084.9 771.1 1082.15 771.4 1079.35 771.7 1079 774.1 1078.4 778.5 1079.15 789.15 1079.15 798.65 1074.9 802.8 1072 805.6 1068.75 804.05 1065.7 802.6 1064.6 798.8 1063.6 795.2 1064.95 790.4 1065.55 788.3 1068 782.4 1069.15 779.7 1066.35 778.3 1063.6 776.9 1061.65 778.7 1054.35 785.55 1045.7 789.65 1035.65 794.35 1030.65 791.2 1024.15 787.1 1030.7 775.9 Z"
				/>
			</g>
		</defs>

		<g transform="matrix( 0.218994140625, 0, 0, 0.218994140625, -32.55,-26.95) ">
			<use xlinkHref="#Layer15_0_FILL" />
		</g>

		<g transform="matrix( 0.218994140625, 0, 0, 0.218994140625, -32.55,-26.95) ">
			<use xlinkHref="#Layer14_0_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer13_0_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer13_1_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer13_2_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer13_3_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer13_4_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer13_5_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer13_6_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer13_7_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer13_8_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer13_9_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer13_10_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer13_11_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer13_12_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer13_13_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer13_14_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer13_15_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer13_16_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer13_17_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer13_18_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer13_19_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer13_20_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer13_21_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer13_22_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer13_23_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer13_24_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer13_25_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer13_26_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer13_27_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer13_28_MEMBER_100_FILL" />
		</g>

		<g transform="matrix( 0.2189788818359375, 0, 0, 0.2189788818359375, -32.55,-26.95) ">
			<use xlinkHref="#Layer13_29_MEMBER_100_FILL" />
		</g>
	</svg>
);
